import { RootState } from '../reducers'

export const urgentNumbersSelector = (state: RootState) => (state.urgentNumbers ? state.urgentNumbers.paging.content : [])

export const lastPageSelector = (state: RootState) => (state.urgentNumbers.paging ? state.urgentNumbers.paging.last : null)

export const urgentNumbersPagingSelector = (state: RootState) => state.urgentNumbers.paging
